module.exports = __webpack_public_path__ + "static/media/cash.8a67e516.png";